module Environments {
    module.directive("environmentsListItem", function () {
        return {
            templateUrl: "EnvironmentsListItemTemplate"
        };
    });
}